<template>
  <div
    class="bp-radio"
    :class="{
      'flex-column justify-content-start gap-3': vertical,
      'flex-row align-items-center gap-5': !vertical
    }"
  >
    <label v-if="label">
      <span class="bp-label functional-1 mr-3 fs-16">{{ label }}</span>
      <span v-if="required" class="text-negative-700">*</span>
    </label>

    <div
      v-for="option in options"
      :key="option.id"
      class="bp-radio__option-wrapper"
    >
      <div class="bp-radio__option">
        <input
          v-model="innerValue"
          type="radio"
          class="bp-radio__input"
          :id="id + '-' + option.id"
          :value="option.id"
          :disabled="disabled || option.disabled"
        />

        <label class="functional-1 bp-radio__label" :for="id + '-' + option.id">
          <span>
            {{ option.name }}
          </span>
          <bp-tooltip v-if="option.warning" :text="option.warning">
            <i class="fa fa-circle-exclamation fs-14 ml-3 text-neutral-500" />
          </bp-tooltip>
        </label>
      </div>

      <div
        class="functional-2 bp-radio__option-description"
        v-if="option.description"
      >
        {{ option.description }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: "bp-radio"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-radio {
  display: flex;

  .bp-radio__option {
    display: flex;
    align-items: center;
    gap: 4px;

    .bp-radio__input {
      transform: none;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        padding: 0;
        width: 18px;
        height: 18px;
        transition: 0.2s background-color;
        border-color: rgba(146, 146, 146, 1);
        background-color: rgba(25, 25, 34, 0.1);
      }

      &:checked::after {
        font-size: 18px;
        padding-bottom: 3px;
        background-color: rgba(131, 35, 255, 1);
        border-color: rgba(131, 35, 255, 1);
      }

      &:disabled {
        cursor: default;
        filter: opacity(0.6);
      }
    }

    .bp-radio__label {
      margin: 0;
      display: flex;
      color: $neutral-600;
      align-items: center;
    }
  }

  .bp-radio__option-description {
    $color: $neutral-500;
  }
  .bp-radio__option-wrapper:has(input:checked) {
    .bp-radio__option-description,
    .bp-radio__label {
      color: $primary-600;
    }
  }
}
</style>
